import store from '@/store';
import { ROLE_KLINIK, ROLE_MANAGEMENT, MENU_SETTING, MENUS } from '../../helpers/constant';

const menu = {
  haveMenuAccess() {
    const klinikUser = store.state.klinikUser;
    const roleInKlinik = store.state.roles.map(r => r.name);
    const hasManajemen = ROLE_MANAGEMENT.filter(r => roleInKlinik.includes(r));

    if (klinikUser.length > 1 || (roleInKlinik.length > 1 && hasManajemen > 0)) {
      if (!MENUS.find(m => m.title == 'Settings') && !store.state.isFaskesDpm){
        MENUS.push(MENU_SETTING)
      }
    }

    return this.filterMenuByRole(MENUS).map(item => ({
      ...item,
      disabled: store.state.sidebar.initializationPage,
    }));
  },
  filterMenuByRole(menus) {
    if (!menus) return [];
    
    const klinikUser = store.state.klinikUser;
    const roleInKlinik = store.state.roles.map(r => r.name);
    const accessProfileKlinik = roleInKlinik.some(r => ROLE_KLINIK.includes(r));

    let res = [];
    menus.forEach(menu => {
      if (menu.child) {
        menu.child = this.filterMenuByRole(menu.child);
      }

      if (menu.type) {
        let valid = false;
        roleInKlinik.forEach(role => {
          if (menu.type.indexOf(role) != -1) valid = true;
        });

        // check satusehat menus
        if (menu.hasOwnProperty('is_satusehat')) {
          if ((+menu.is_satusehat) != store.state.satusehatAuthValid) {
            valid = false;
          }
        }

        // profile user
        if (menu.hasOwnProperty('is_profile_user')) {
          menu.title = accessProfileKlinik ? 'Profil Pengguna' : 'Profil Dokter';
          menu.href = accessProfileKlinik ? '/account-setting/klinik' : '/account-setting/profile';
        }

        if (store.state.faskes == 2) {
          if (
            valid &&
            menu.title != 'Settings' &&
            menu.title != 'Ubah Klinik'
          )
            res.push(menu);
        } else {
          if (klinikUser.length > 1) {
            if (valid) res.push(menu);
          } else {
            if (
              valid &&
              menu.title != 'Settings' &&
              menu.title != 'Ubah Klinik'
            )
              res.push(menu);
          }
        }
      }
    });
    return res;
  },
  checkMenuAccess(route) {
    const roleInKlinik = store.state.roles.map(r => r.name);
    const access = route.meta && route.meta.role;
    
    let result = false;
    if (access && access.find(a => roleInKlinik.includes(a))) result = true;
    return result;
  },
  checkRouteLink(route, href) {
    let result = false;
    if (route && href) {
      if (route.replace(/[^a-zA-Z0-9]/g, '').includes(href.replace(/[^a-zA-Z0-9]/g, ''))) {
        result = true;
      }
    }
    return result;
  },
};

export default menu;
